import * as React from 'react';
import { PropsWithChildren, useContext, ReactNode } from 'react';
import { ConfigContext } from 'modules/context';
import { Element as ReactScrollElement } from 'react-scroll';

import { SUB_CONTENT_SCROLL_ELEMENT } from '../content.constants';
import GameLogo from '../../game-logo';

const ContentView: React.FC<PropsWithChildren<ReactNode>> = ( { children }) => {
    const { config: { shouldInheritStyles }, getModeClass } = useContext(ConfigContext);
    return (<div className={getModeClass('sitegen-content-wrapper')}>
        <div className={getModeClass('sitegen-content')}>
            {shouldInheritStyles ? null : <GameLogo />}

            <ReactScrollElement
                className={getModeClass('sitegen-sub-content')}
                name={SUB_CONTENT_SCROLL_ELEMENT}
            >
                {children}
            </ReactScrollElement>
        </div>
    </div>);
};

export default ContentView;
